<template>
  <transition name="modal">
    <div class="modal-mask">
      <Spinner
        v-if="!barraProgreso"
        id="loading"
        name="ball-scale-ripple-multiple"
        color="#1a8cff"
      />
      <div class="progress-container">
        <div class="progress">
          <v-progress-circular
            v-if="barraProgreso"
            :rotate="-90"
            :size="120"
            :width="15"
            :value="valorProgreso"
            color="primary"
          >{{ valorProgreso }}</v-progress-circular>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Vue from "vue";
import Spinner from "vue-spinkit";

Vue.component("Spinner", Spinner);
export default {
  props: {
    barraProgreso: {
      type: Boolean,
      default: false
    },
    valorProgreso: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
  justify-content: center;
  align-items: center;
}
.v-progress-circular .v-progress-circular__info {
  font-weight: bold;
  font-size: 18px;
}
.progress-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.progress {
  animation: progress-beat 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
}
@keyframes progress-beat {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
/* #33ccff */


</style>





// WEBPACK FOOTER //
// src/components/Loading.vue